import React, { useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import SettingsTable from '../../../../components/tables/SettingsTable';
import ServicesModal from '../../../../components/modals/ServicesModal';

const Services = () => {
  // Sample data generator
  const generateSampleData = (count = 30) => {
    const serviceNames = [
      'Mobile Recharge', 'DTH Recharge', 'Bill Payment', 'Money Transfer',
      'AEPS', 'Aadhaar Pay', 'Fund Transfer', 'Payout',
      'UPI Payment', 'QR Code', 'Fastag', 'LIC Premium',
      'Insurance', 'Loan Repayment', 'Credit Card', 'Broadband'
    ];
    const icons = [
      'bi bi-phone', 'bi bi-broadcast', 'bi bi-receipt', 'bi bi-arrow-left-right',
      'bi bi-credit-card', 'bi bi-fingerprint', 'bi bi-cash-stack', 'bi bi-wallet2',
      'bi bi-upc', 'bi bi-qr-code', 'bi bi-car-front', 'bi bi-shield-check',
      'bi bi-umbrella', 'bi bi-piggy-bank', 'bi bi-credit-card-2-front', 'bi bi-router'
    ];
    
    return Array.from({ length: count }, (_, i) => ({
      serviceName: serviceNames[i % serviceNames.length],
      serviceStatus: Math.random() > 0.3 ? 'Active' : 'Inactive',
      onOffScreen: Math.random() > 0.2 ? 'On' : 'Off',
      priority: i + 1,
      icon: icons[i % icons.length]
    }));
  };

  const [data, setData] = useState(generateSampleData(30));
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState('add');
  const [selectedService, setSelectedService] = useState(null);

  const handleAddService = () => {
    setModalMode('add');
    setSelectedService(null);
    setShowModal(true);
  };

  const handleEditService = (service) => {
    setModalMode('edit');
    setSelectedService(service);
    setShowModal(true);
  };

  const handleSaveService = (serviceData) => {
    if (modalMode === 'add') {
      setData([...data, serviceData]);
    } else {
      setData(data.map(item => 
        item.serviceName === selectedService.serviceName && item.priority === selectedService.priority
          ? { ...item, ...serviceData }
          : item
      ));
    }
  };

  // Column definitions
  const columns = [
    {
      key: 'actions',
      label: 'Actions',
      render: (row) => (
        <div className="d-flex gap-1 justify-content-center">
          <Button 
            size="sm" 
            className="btn-outline-primary-custom"
            title="Edit"
            style={{
              padding: '0.25rem 0.5rem'
            }}
            onClick={() => handleEditService(row)}
          >
            <i className="bi bi-pencil"></i>
          </Button>
        </div>
      )
    },
    { key: 'serviceName', label: 'Service Name' },
    { key: 'serviceStatus', label: 'Service Status' },
    { key: 'onOffScreen', label: 'On/Off-Screen' },
    { key: 'priority', label: 'Priority' },
    { 
      key: 'icon', 
      label: 'Icon',
      render: (row) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <i className={row.icon} style={{ fontSize: '1.8rem', color: '#667eea' }}></i>
        </div>
      )
    }
  ];

  return (
    <Container fluid className="p-4">
      <SettingsTable
        data={data}
        settingsType="Services"
        columns={columns}
        onAdd={handleAddService}
      />
      <ServicesModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        mode={modalMode}
        serviceData={selectedService}
        onSave={handleSaveService}
      />
    </Container>
  );
};

export default Services;

